<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">

                    <v-row dense>
                        <v-col cols="12">
                            <span color="black" class="headline text-xs-center" v-text="'Datos Plan Cobertura'"></span>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="6"></v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Buscar" color="textbox" v-model="obModal.busqueda" dense clearable prepend-inner-icon="search" />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-data-table :search="obModal.busqueda" :headers="listGeneral.cabeceraPlanCob"
                                :items="listGeneral.detallePlanCob" class="elevation-3" >

                                 <template v-slot:item.seleccionar="{ item }">
                                    <v-checkbox v-model="item.check" @change="onCheck(item)"></v-checkbox>
                                    <!-- <v-simple-checkbox v-model="item.check" :ripple="false" @click="onCheck(item)"></v-simple-checkbox> -->
                                </template>

                                <template v-slot:no-results>
                                    Tu búsqueda de "<span v-text="obModal.busqueda"></span>" no arrojó resultados.
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <v-row dense class="mt-3 mb-3" align="center" justify="center" >
                        <v-col cols="12" class="text-center">
                            <v-icon color="secundary" class="btnNext" @click="siguiente" :disabled="!isCheck">arrow_forward</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowDatosPlanCoberturaComponent',
        inject:['siguiente','setData'],
        props: {
            listGeneral: {
                type: Object,
                default: {}
            },
            obModal: {
                type: Object,
                default: {}
            },
            active:{
                type:Boolean,
                default:false
            }
        },
        data: ()=>({
            cabecera:[
                {text:'Nombre Plan', value:'nombre',class:'caption text-xs-center active'},
				{text:'Tipo Plan', value:'nombreEstado' ,class:'caption text-xs-center' },
                {text:'Selección Cobertura Cliente', value:'seleccionCoberturaCliente' ,class:'caption text-xs-center'},
                {text:'Seleccionar', value:'seleccionar' ,class:'caption text-xs-center'}
            ],
            isCheck:false,
            idPlanProducto:null
        }),
        created(){
            this.listGeneral.cabeceraPlanCob = this.cabecera;
            this.onListar('L');
        },
        watch:{
            active(val){
                if(val && _.size(this.listGeneral.detallePlanCob) == 0){
                    this.listGeneral.cabeceraPlanCob = this.cabecera;
                    this.onListar('L');
                }
            }
        },
        methods:{
            onCheck(v){
                this.isCheck = v.check;
                /**
                 * detalleDetPlanCob
                 * listCobertura
                 * detalleDocumentos
                 */
                if(v.check){
                    var k = ['idPlanProducto','idTipoPlan','idSeleccionCoberturaCliente','nombrePlan','tipoPlan','seleccionCoberturaCliente'];
                    var oo = _.pick(_.mapKeys(_.cloneDeep(v),_.rearg(_.camelCase,1)),k);
                    this.setData('obModal',oo);
                    this.reset();
                    this.siguiente();
                }
            },
            onListar(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    var objeto = {
                        opcion: 'L',
                        idProducto: this.obModal.idProducto,
                        idEstado: this.obModal.idEstado
                    };
                    this.listGeneral.detallePlanCob = [];

                    axios.post(`${BASE_URI}administrador/planCobertura/listar`,objeto)
                        .then((r) =>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                var l = _.cloneDeep(r.data.data);
                                l = _.map(l,(v)=>{
                                        v.nombre = v.nombre_plan;
                                        v.nombreEstado = v.tipoPlan;
                                        v.seleccionCoberturaCliente = v.seleccion_cobertura_cliente;
                                        v.check = false;
                                    return v;
                                });
                                this.setData('listGeneral.detallePlanCob',l,false);
                                this.$forceUpdate();
                        })
                        .catch((e) =>{
                                mensajesAlerta(e, error);
                        });
                }
            },
            reset(){
                var r = ['detalleDetPlanCob', 'listCobertura', 'detalleDocumentos'];
                if(_.toNumber(this.idPlanProducto) != _.toNumber(this.obModal.idPlanProducto)){
                    this.idPlanProducto = this.obModal.idPlanProducto;

                    _.forEach(r,(v)=>{
                        this.setData(`listGeneral.${v}`,[],false);
                    });
                }
            }
        }
    }
</script>
